import { NavBar } from './NavBar';
// import { Link } from 'react-router-dom';
import SearchQuery from './SearchQuery';
import { MobileNavBar } from './MobileNavBar';
import Logo from '../Logo';
import React, { useEffect, useRef } from 'react';
import { getCartSummary } from '../../../features/cart/cartSlice';
import { useSelector } from 'react-redux';

const Header = () => {
  const userID = useSelector((state) => state?.user?.data?.userID);
  const cart = useSelector((state) => state?.cart?.cart);
  const cartSummary = useSelector(getCartSummary);
  const totalCartQuantity = cartSummary?.total_items || 0;
  const totalCartPrice = cartSummary?.subtotal || 0;
  const lastTrackedCartId = useRef(null);

  const cartMP = {
    totalItems: totalCartQuantity,
    totalValue: totalCartPrice,
    userId: userID,
    items: cart,
  };

  // console.log(cart);

  //Mixpanel to track cart abandoned
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (
        cartMP?.totalItems > 0 &&
        cartMP?.userId !== lastTrackedCartId.current //  prevent duplicates
      ) {
        trackCartAbandoned(cartMP);
        lastTrackedCartId.current = cartMP?.userId; // remember last sent cart
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [cartMP]);

  return (
    <header
      className="max-w-[1740px] mx-auto w-full fixed top-0 left-0 right-0 bg-white z-30 py-4 flex justify-between lg:border-b border-gray-200 transition-all motion-safe:duration-200"
      role="banner"
      aria-label="Main site navigation"
    >
      <div className="hidden lg:flex justify-between items-center w-full px-4 sm:px-6 lg:px-10 max-w-full mx-auto">
        <Logo />
        <SearchQuery />
        <NavBar />
      </div>

      {/* Mobile view header */}
      <div className="grid gap-4 lg:hidden w-full px-4 sm:px-6 ">
        <div className="flex justify-between items-center">
          <Logo className="motion-safe:transition-transform" />
          <MobileNavBar />
        </div>
        <SearchQuery />
      </div>
    </header>
  );
};

export default React.memo(Header);
